import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosubmit-form"
export default class extends Controller {
  static targets = ["input"]

  inputTargetConnected(input) {
    this.addChangeListener(input)
  }

  addChangeListener(input) {
    input.addEventListener("change", () => {
      this.element.dataset.triggeredInputId = input.id
      this.submitForm()
    })
  }

  submitForm() {
    this.element.requestSubmit()
  }
}
